export function shouldShowCreateItems({
	searchQuery,
	debouncedQuery,
	isFetching,
	resultCount,
}: {
	searchQuery: string
	debouncedQuery: string
	isFetching: boolean
	resultCount: number
}): boolean {
	if (!searchQuery.trim()) return true
	const isSearchSettled = debouncedQuery === searchQuery && !isFetching
	return isSearchSettled && resultCount === 0
}
